import React, { useEffect } from "react";
import {
  BlogIcon,
  ChatavirsityIcon,
  ContactIcon,
  CrossIcon,
  DashboardIcon,
  FaqIcon,
  LoggedConnectionsIcon,
  ScheduledIcon,
  SettingsIcon,
  SidebarImg,
  TeamsIcon,
} from "./Icon";
import { useStateProvider } from "./StateProvider";

import { Link, useLocation } from "react-router-dom";
import chatalottlogo from "../../assets/images/svg/chatalott_logo.svg";
import NotificaitonPage from "../notificaiton/NotificaitonPage";
import AppRouter from "./AppRouter";
const Sidbar = () => {
  const { setShowTabs, showNotificaitonPage, showData, setShowData } =
    useStateProvider(); // SET ACTIVE TAB OF SIDEBAR

  useEffect(() => {
    if (showData) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showData]);

  // OVERLAY BEHIND MOBILENAV
  const overLayHidden = () => {
    setShowData(!showData);
  };
  const location = useLocation();

  return (
    <>
      <div className="relative py-4 bg-[#6F6AF8] overflow-hidden h-screen">
        <div className="flex overflow-hidden">
          <div
            className={` w-[300px] lg:w-[280px] bg-[#6F6AF8] h-screen xl:w-[280px]  !overflow-y-scroll sidebar_Scrollbar pt-[17px] absolute lg:static sm:!top-0 md:top-[76px]  z-[10]  duration-300 ${
              showData ? "left-[0] !z-40" : "left-[-980px]"
            }`}>
            <div className=" flex items-center justify-between pb-[22px]">
              <Link to="/" className="inline-block">
                <img
                  className=" w-full ps-[25px]"
                  src={chatalottlogo}
                  alt="chatalottlogo"
                />
              </Link>
              <button
                aria-label="Closelink"
                className=" lg:hidden me-2"
                onClick={() => setShowData(!showData)}>
                <CrossIcon />
              </button>
            </div>

            {/* SIDEBAR LIKES */}

            <div className=" pb-5 overflow-y-auto h-[88vh]  pt-4">
              <div className="">
                <Link
                  to="/"
                  onClick={() => {
                    setShowTabs("dashboard");
                    setShowData(false);
                  }}
                  className={`flex gap-2 items-center  w-full duration-200 ps-4 border-l-4 border-solid hover:border-[#FFF] hover:bg-[#00000026]/[15%] border-transparent py-2 ${
                    location.pathname === "/"
                      ? " !border-[#FFF] bg-[#00000026]/[15%] "
                      : location.pathname === "/productivity-description"
                      ? "!border-[#FFF] bg-[#00000026]/[15%]"
                      : ""
                  }`}>
                  <DashboardIcon />{" "}
                  <span className=" font-normal text-sm 3xl:text-base  text-white">
                    Dashboard
                  </span>
                </Link>
              </div>
              <div className="pt-4">
                <Link
                  to="/my-team"
                  onClick={() => {
                    setShowTabs("myteam");
                    setShowData(false);
                  }}
                  className={`flex gap-2 items-center  w-full duration-200 ps-4 border-l-4 border-solid hover:border-[#FFF] hover:bg-[#00000026]/[15%] border-transparent py-2 ${
                    location.pathname === "/my-team"
                      ? " !border-[#FFF] bg-[#00000026]/[15%]"
                      : ""
                  }`}>
                  <TeamsIcon />{" "}
                  <span className=" font-normal text-sm 3xl:text-base  text-white">
                    My Teams
                  </span>
                </Link>
              </div>
              <div className="pt-4">
                <Link
                  to="/my-contact"
                  onClick={() => {
                    setShowTabs("mycontact");
                    setShowData(false);
                  }}
                  className={`flex gap-2 items-center  w-full duration-200 ps-4 border-l-4 border-solid hover:border-[#FFF] hover:bg-[#00000026]/[15%] border-transparent py-2 ${
                    location.pathname === "/my-contact"
                      ? " !border-[#FFF] bg-[#00000026]/[15%] "
                      : ""
                  }`}>
                  <ContactIcon />{" "}
                  <span className=" font-normal text-sm 3xl:text-base  text-white">
                    My Contact
                  </span>
                </Link>
              </div>
              <div className="pt-4">
                <Link
                  to="/scheduled"
                  onClick={() => {
                    setShowTabs("scheduled");
                    setShowData(false);
                  }}
                  className={`flex gap-2 items-center  w-full duration-200 ps-4 border-l-4 border-solid hover:border-[#FFF] hover:bg-[#00000026]/[15%] border-transparent py-2 ${
                    location.pathname === "/scheduled"
                      ? " !border-[#FFF] bg-[#00000026]/[15%] "
                      : ""
                  }`}>
                  <ScheduledIcon />{" "}
                  <span className=" font-normal text-sm 3xl:text-base  text-white">
                    Scheduled
                  </span>
                </Link>
              </div>
              <div className="pt-4">
                <Link
                  to="/my-blogs"
                  onClick={() => {
                    setShowTabs("blog");
                    setShowData(false);
                  }}
                  className={`flex gap-2 linkClass items-center  w-full duration-200 ps-4 border-l-4 border-solid hover:border-[#FFF] hover:bg-[#00000026]/[15%] border-transparent py-2 ${
                    location.pathname === "/my-blogs" ||
                    location.pathname.includes("/blog-description")
                      ? " !border-[#FFF] bg-[#00000026]/[15%]"
                      : ""
                  }`}>
                  <BlogIcon />{" "}
                  <span className=" font-normal text-sm 3xl:text-base  text-white">
                    Blog
                  </span>
                </Link>
              </div>
              <div className="pt-4">
                <Link
                  to="/my-chatavirsity"
                  onClick={() => {
                    setShowTabs("chatavirsity");
                    setShowData(false);
                  }}
                  className={`flex gap-2 items-center  w-full duration-200 ps-4 border-l-4 border-solid hover:border-[#FFF] hover:bg-[#00000026]/[15%] border-transparent py-2 ${
                    location.pathname === "/my-chatavirsity" ||
                    location.pathname.includes("/chatavirsity-description")
                      ? " !border-[#FFF] bg-[#00000026]/[15%] "
                      : ""
                  }`}>
                  <ChatavirsityIcon />{" "}
                  <span className=" font-normal text-sm 3xl:text-base  text-white">
                    Chatavirsity
                  </span>
                </Link>
              </div>
              <div className="pt-4">
                <Link
                  to="/setting/my-account"
                  onClick={() => {
                    setShowTabs("settings");
                    setShowData(false);
                  }}
                  className={`flex gap-2 items-center  w-full duration-200 ps-4 border-l-4 border-solid hover:border-[#FFF] hover:bg-[#00000026]/[15%] border-transparent py-2 ${
                    location.pathname.includes("/setting")
                      ? " !border-[#FFF] bg-[#00000026]/[15%] "
                      : ""
                  }`}>
                  <SettingsIcon />{" "}
                  <span className=" font-normal text-sm 3xl:text-base  text-white">
                    Settings
                  </span>
                </Link>
              </div>
              <div className="pt-4">
                <Link
                  to="/faq"
                  onClick={() => {
                    setShowTabs("faq");
                    setShowData(false);
                  }}
                  className={`flex gap-2 items-center  w-full duration-200 ps-4 border-l-4 border-solid hover:border-[#FFF] hover:bg-[#00000026]/[15%] border-transparent py-2 ${
                    location.pathname === "/faq"
                      ? " !border-[#FFF] bg-[#00000026]/[15%] "
                      : ""
                  }`}>
                  <FaqIcon />{" "}
                  <span className=" font-normal text-sm 3xl:text-base  text-white">
                    FAQ
                  </span>
                </Link>
              </div>
              <div className="pt-4">
                <Link
                  to="/logout"
                  onClick={() => {
                    setShowTabs("loggedConnections");
                    setShowData(false);
                  }}
                  className={`flex gap-2 items-center  w-full duration-200 ps-4 border-l-4 border-solid hover:border-[#FFF] hover:bg-[#00000026]/[15%] border-transparent py-2 ${
                    location.pathname === "/logout"
                      ? " !border-[#FFF] bg-[#00000026]/[15%] "
                      : ""
                  }`}>
                  <LoggedConnectionsIcon />{" "}
                  <span className=" font-normal text-sm 3xl:text-base  text-white">
                    Logged Connections
                  </span>
                </Link>
              </div>
              <span className=" flex justify-center mt-6">
                <SidebarImg />
              </span>
              <div className=" flex justify-center">
                <button className="text-sm font-normal text-white rounded-[42px] p-[10px_46px] mt-5 bg-graf hover:bg-[linear-gradient(180deg,_#FE73F0_0%,_#FFC0F9_100%)] duration-300 border-0">
                  Contact Us
                </button>
              </div>
            </div>
          </div>
          {showNotificaitonPage ? (
            <NotificaitonPage />
          ) : (
            <div className=" w-full lg:me-4  ">
              {/* {showTabs === "dashboard" && <Dashboard />}
              {showTabs === "myteam" && <MyTeam />}
              {showTabs === "mycontact" && <MyContact />}
              {showTabs === "scheduled" && <Dashboard />}
              {showTabs === "blog" && <MyBlogs />}
              {showTabs === "chatavirsity" && <MyChatavirsity />}
              {showTabs === "settings" && <SettingsPage />}
              {showTabs === "faq" && <Faq />}
              {showTabs === "loggedConnections" && <LogoutPage />} */}
              <AppRouter />
            </div>
          )}
        </div>
      </div>
      <div
        onClick={overLayHidden}
        className={` fixed inset-0 min-h-full z-10  bg-black opacity-10 ${
          showData ? "w-[100%] " : "hidden"
        }`}></div>
    </>
  );
};

export default Sidbar;
